import slugify from 'slugify';
import {storeToRefs} from 'pinia';
import type {Badge} from '~/types/product';
import type {Gsoa_ProductCatalog_Badges as ProductCatalogBadges} from '~/openapi';
import type {SanitizedCategoryWithProductCount as Category} from '~/stores/actionOffer';
import {useCustomerProfileStore} from '~/stores/customerProfile';
import {THISANDTHAT} from '#shared/constants';

export function getProductCategorySlug(category?: {categoryName: string}): string {
	return category
		? slugify(category.categoryName, {lower: true})
		: '';
}

export function createProductBadges(...names: Badge[]): ProductCatalogBadges {
	return names.reduce((badges, name) => ({
		...badges,
		[name]: {display: true},
	}), {} as ProductCatalogBadges);
}

export function canUserAccessCategory(category?: Category): boolean {
	if (!category) {
		return false;
	}

	if (category.categoryId === THISANDTHAT.id) {
		const {userIsLogged} = storeToRefs(useCustomerProfileStore());
		return userIsLogged.value;
	}

	return true;
}

export function removeDecimalComma(value: string): string {
	const match = value.match(/^(\d+),00\s*(.*)$/);
	if (match) {
		return `${match[1]} ${match[2]}`.trim();
	}
	return value;
}
